import { __ } from "@wordpress/i18n";
import { useEffect, useState, useRef } from "@wordpress/element";
const { withSelect } = wp.data;

import Settings from "./settings";
import Viewer from "./Components/Viewer";
import { useWPAjaxQuery } from "../../../../wp-utils/v1";

const Edit = (props) => {
  const { clientId, attributes, setAttributes, isSelected, postType } = props;
  const [isValid, setIsValid] = useState(true);
  const { uniqueId, model, models, multiple, additional, align, woo, isPremium = true } = attributes;
  const { data, isLoading } = useWPAjaxQuery(bp3dBlock?.ajaxURL, { action: "bp3d_pipe_checker", _wpnonce: bp3dBlock?.nonce });


  
  const viewerRef = useRef();

  //generate new unique ID
  useEffect(() => {
    const woo = ["product", null].includes(postType) ? true : false;
    setAttributes({ uniqueId: "b3dviewer" + clientId.substr(0, 8), woo });
  }, []);

  useEffect(() => {
    setAttributes({ isPremium: data?.isPipe });
    if (!data?.isPipe && !isLoading) {
      setAttributes({ multiple: false });
    }
  }, [data, isLoading]);

  useEffect(() => {
    try {
      new URL(modelSrc);
      setIsValid(true);
    } catch (error) {
      setIsValid(false);
    }
  }, [uniqueId, model, models, multiple]);

  const modelSrc = multiple ? models[0]?.modelUrl : model?.modelUrl;

  if (isLoading) {
    return <h2>Loading...</h2>;
  }

  return (
    <>
      {/* <div id={`${uniqueId}`} className={`b3dviewer align${align} ${woo ? "woocommerce" : ""}`}> */}
      {!isSelected && <div className="modelViewerIsSelected"></div>}
      <>
        <Settings attributes={attributes} setAttributes={setAttributes} viewerRef={viewerRef} />

        {modelSrc && isValid && <Viewer viewerRef={viewerRef} setAttributes={setAttributes} attributes={attributes} __={__} />}
        {modelSrc && !isValid && <h2>{__("3D file not valid", "model-viewer")}</h2>}
        {!modelSrc && <h2>{__("Click here to upload 3D Models", "model-viewer")}</h2>}
      </>
      {/* </div> */}
    </>
  );
};

export default withSelect((select) => {
  const { isEditorSidebarOpened } = select("core/edit-post");
  const postType = select("core/editor")?.getCurrentPostType() || "product";
  return {
    isSidebarOpened: isEditorSidebarOpened(),
    postType,
  };
})(Edit);
